import React from 'react';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
export function CTASection() {
  return <section id="pricing" className="py-24 bg-white text-center scroll-mt-20" data-id="element-33">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-34">
        <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#1a3a52] mb-6" data-id="element-35">
          Estás a una pausa de distancia de transformar tu día
        </h2>

        <div className="mb-8" data-id="element-36">
          <span className="text-lg text-gray-500 line-through mr-3" data-id="element-37">
            $19.99
          </span>
          <span className="text-3xl md:text-4xl font-bold text-[#1a3a52]" data-id="element-38">
            $6.39 USD
          </span>
          <span className="ml-3 inline-block bg-[#d4af37] text-[#1a3a52] px-3 py-1 rounded-full text-sm font-bold" data-id="element-39">
            68% OFF
          </span>
        </div>

        <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto" data-id="element-40">
          Comienza hoy tu camino hacia la calma con esta oferta especial.
        </p>

        <div className="flex flex-col items-center space-y-6" data-id="element-41">
          <Button size="lg" className="px-12 py-6 text-xl shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300" onClick={() => window.open('https://fuentedevida.it.com//cart/42965875949634:1', '_blank')} data-id="element-42">
            Acceder a la Guía Ahora
          </Button>

          <div className="flex items-center space-x-2 text-gray-500 text-sm" data-id="element-43">
            <ShieldCheck className="w-4 h-4" data-id="element-44" />
            <span data-id="element-45">Pago seguro y encriptado</span>
          </div>

          <p className="text-xs text-gray-400 max-w-md" data-id="element-46">
            Al realizar la compra recibirás acceso inmediato a todo el material
            digital en tu correo electrónico.
          </p>
        </div>
      </div>
    </section>;
}